import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createTrustRule } from "./api";
import type { TrustRuleCreateRequest, TrustRuleResponse } from "./api";

// На успешный POST инвалидируем список правил — таблица перерисуется
// с новым правилом без ручного refetch'а.
export function useCreateTrustRule(): ReturnType<
  typeof useMutation<TrustRuleResponse, Error, TrustRuleCreateRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<TrustRuleResponse, Error, TrustRuleCreateRequest>({
    mutationFn: (body) => createTrustRule(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["trustRules"],
      });
    },
  });
}
